import React from "react";
import "./translitration.css";
import { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Img1 from "./../../assets/portfolio/music1.jpg";
import Img2 from "./../../assets/portfolio/music2.png";
import Img3 from "./../../assets/portfolio/music3.png";
import Img4 from "./../../assets/portfolio/music4.png";
import Img5 from "./../../assets/portfolio/music5.png";
import MusicListPlayer from "../../components/musicplayer/Musicplayer";
import music7 from "./../../assets/music/kala-songs.mp3";
import { useTranslation } from "react-i18next";

const Translitration = () => {
  const { t } = useTranslation();
  const tracks = [{ title: "kaka songs", src: music7 }];
  // const [modalShow, setModalShow] = useState(false);

  let sliderRef = useRef(null);
  const next = () => {
    sliderRef.slickNext();
  };
  const previous = () => {
    sliderRef.slickPrev();
  };
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="">
      <div className="translitration-container">
        <div className="wrapper ">
          <div className="">
            <h1>{t("Created at Roger")}</h1>
          </div>
          <div className="">
            <div className="w-100 d-flex justify-content-between items-start Studio-section-crousel ">
              <h4>Виконавці</h4>
              <div className=" d-flex justify-content-end align-items-center gap-3 ">
                <div className="left-btn" onClick={previous}>
                  <SVGLeft />
                </div>
                <div className="left-btn" onClick={next}>
                  <SVGRight />
                </div>
              </div>
            </div>

            <div className="slider-container">
              <Slider
                ref={(slider) => {
                  sliderRef = slider;
                }}
                {...settings}
              >
                <div key={1} className="Slider-card h-100">
                  <img src={Img1} alt="" />
                  <div className="mt-3 w-100 h-100 d-flex flex-column justify-content-center align-items-center py-2 gap-2">
                    <h3>Translitertion</h3>
                    <p>Rock</p>
                  </div>
                </div>
                <div key={2} className="Slider-card h-100">
                  <img src={Img2} alt="" />
                  <div className="mt-3 w-100 h-100 d-flex flex-column justify-content-center align-items-center py-2 gap-2">
                    <h3>Rozpach</h3>
                    <p>Rock</p>
                  </div>
                </div>
                <div key={3} className="Slider-card h-100">
                  <img src={Img3} alt="" />
                  <div className="mt-3 w-100 h-100 d-flex flex-column justify-content-center align-items-center py-2 gap-2">
                    <h3>TaRIK</h3>
                    <p>Rock</p>
                  </div>
                </div>
                <div key={4} className="Slider-card h-100">
                  <img src={Img4} alt="" />
                  <div className="mt-3 w-100 h-100 d-flex flex-column justify-content-center align-items-center py-2 gap-2">
                    <h3>Нескорені</h3>
                    <p>Rock</p>
                  </div>
                </div>
                <div key={5} className="Slider-card h-100">
                  <img src={Img5} alt="" />
                  <div className="mt-3 w-100 h-100 d-flex flex-column justify-content-center align-items-center py-2 gap-2">
                    <h3>Danvdele</h3>
                    <p>Rock</p>
                  </div>
                </div>
                <div key={6} className="Slider-card h-100">
                  <img src={Img3} alt="" />
                  <div className="mt-3 w-100 h-100 d-flex flex-column justify-content-center align-items-center py-2 gap-2">
                    <h3>Нескорені</h3>
                    <p>Rock</p>
                  </div>
                </div>
                <div key={7} className="Slider-card h-100">
                  <img src={Img4} alt="" />
                  <div className="mt-3 w-100 h-100 d-flex flex-column justify-content-center align-items-center py-2 gap-2">
                    <h3>Rozpach</h3>
                    <p>Rock</p>
                  </div>
                </div>
              </Slider>
            </div>
          </div>

          {/* <h2 onClick={() => setModalShow(true)}>Треки Translitertion </h2> */}
          <h2>Треки Translitertion </h2>

          <MusicListPlayer tracks={tracks} />
        </div>
      </div>
      {/* <Footer /> */}
      {/* <VerifyModel show={modalShow} onHide={() => setModalShow(false)} /> */}
    </div>
  );
};

export default Translitration;

export const SVGLeft = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M14 19L7 12L14 5"
        stroke="#07BE72"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SVGRight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9.99976 5L16.9998 12L9.99976 19"
        stroke="#07BE72"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
